import React from "react";
import { Link } from "react-router-dom";
import heroImg from "../assets/hero-image.jpg"; // update the filename if needed
import "./Hero.css";

function Hero() {
  return (
    <section className="hero">
      {/* Ambient background elements */}
      <div className="hero-blob-2" aria-hidden="true"></div>
      <div className="hero-blob-3" aria-hidden="true"></div>
      <div className="hero-grid-glow" aria-hidden="true"></div>
      
      <div className="hero-text">
        <span className="hero-kicker">Enterprise technology, delivered clearly</span>
        <h1>Revolutionizing Business - Building Intelligent Future Focused Solutions</h1>
        <p>
          We build elegant solutions with cutting-edge technology to help your business thrive.
        </p>

        <div className="hero-actions">
          <Link to="/services" className="hero-btn hero-btn-primary">Explore Services</Link>
          <a href="#contact" className="hero-btn hero-btn-secondary">Start a Conversation</a>
        </div>

        <div className="hero-metrics" aria-label="Nexite highlights">
          <div className="hero-metric">
            <strong>50+</strong>
            <span>projects shipped</span>
          </div>
          <div className="hero-metric">
            <strong>24/7</strong>
            <span>operational support</span>
          </div>
          <div className="hero-metric">
            <strong>4</strong>
            <span>core service lines</span>
          </div>
        </div>
      </div>
      <div className="hero-image">
        <div className="hero-img-frame" aria-hidden="false">
          {/* Corner accents */}
          <span className="hf-corner hf-tl" aria-hidden="true" />
          <span className="hf-corner hf-tr" aria-hidden="true" />
          <span className="hf-corner hf-bl" aria-hidden="true" />
          <span className="hf-corner hf-br" aria-hidden="true" />
          {/* Glow ring */}
          <span className="hf-ring" aria-hidden="true" />
          {/* Image */}
          <img src={heroImg} alt="Innovation at Nexite" />
          {/* Floating badges */}
          <div className="hf-badge hf-badge-tl">
            <span className="hf-badge-dot" />
            <span>AI-Powered</span>
          </div>
          <div className="hf-badge hf-badge-br">
            <span className="hf-badge-dot hf-badge-dot-green" />
            <span>Enterprise Ready</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
